/* import __COLOCATED_TEMPLATE__ from './conversation-state.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const ConversationState = templateOnlyComponent<Signature>();
export default ConversationState;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Onboarding::ConversationDetailsSidebar::ConversationState': typeof ConversationState;
    'inbox2/onboarding/conversation-details-sidebar/conversation-state': typeof ConversationState;
  }
}
